import { AlertTriangle, WifiOff } from "lucide-react";
import { useTelemetryStatus } from "@/lib/electron";
import { telemetryNotice } from "@/lib/telemetry-notice";

/** Says when position reports are not reaching FlyVAC (telemetry-notice.js).
 *  Only during a flight, only in the desktop app. */
export default function TelemetryNotice({ active, compact = false }) {
  const { status, badSince } = useTelemetryStatus();
  if (!active?.id) return null;
  const n = telemetryNotice(status, badSince);
  if (!n) return null;
  const tone = n.tone === "error"
    ? "border-red-500/50 bg-red-500/10 text-red-800 dark:text-red-200"
    : "border-amber-500/50 bg-amber-500/10 text-amber-900 dark:text-amber-200";
  const Icon = n.tone === "error" ? AlertTriangle : WifiOff;
  return (
    <div role="status" data-testid="telemetry-notice"
      className={`rounded-md border px-3 py-2 text-xs leading-relaxed ${tone}`}>
      <div className="flex items-center gap-1.5 font-semibold">
        <Icon className="w-3.5 h-3.5 shrink-0" />
        {n.title}
      </div>
      {!compact && <div className="mt-0.5 opacity-90">{n.text}</div>}
    </div>
  );
}
